import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { Inner } from "@/features/FillOutWizard/CreateFillOutRequest";
import { FillOutRequestFormQuery } from "@/features/FillOutWizard/CreateFillOutRequest/graphql";
import { zodRespondentTypeEnum } from "@/models/respondent";
import { useSessionContext } from "@/session";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request",
)({
  validateSearch: zodValidator(
    z.object({
      respondentType: zodRespondentTypeEnum,
      measuredQuestionnaireIds: z.array(z.string()),
    }),
  ),
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationKey, dossierId, measurementId } = Route.useParams();
  const { user } = useSessionContext();
  const { respondentType, measuredQuestionnaireIds } = Route.useSearch();
  const { data } = useSuspenseQuery(FillOutRequestFormQuery, {
    variables: {
      organizationKey: organizationKey,
      dossierId: dossierId,
      measurementId: measurementId,
      measuredQuestionnaireIds: measuredQuestionnaireIds,
      teamId: user.team?.id,
      respondentType: respondentType,
    },
  });
  const measurement = data.organization.measurement;
  const notificationTemplates = data.organization.notificationTemplates;
  const respondent = data.dossier.respondent;

  return (
    <Inner
      measurement={measurement}
      notificationTemplates={notificationTemplates}
      respondent={respondent || null}
      respondentType={respondentType}
      measuredQuestionnaireIds={measuredQuestionnaireIds}
    />
  );
}
